<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AysyWI/tc-custom/scover.jpg?1692044807109?1713839778646" alt="This image is the cover for the book Worst. Power. Ever., Vic and Matt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Worst. Power. Ever., Vic and Matt
      </h1>
      <p class="bookDescription body article font2">
        <i>A Vic and Matt Story</i> <br/><br/>Vic Braunson shares a very sexy secret with his lover, Matt diLorenzo -- something in Matt's semen gives Vic superhuman powers. While the powers fade over time, most of them come in handy. But every now and then, he draws a doozy ...<br/><br/>This short, erotic romp was originally written as part of the series, <i>The Positions of Love</i> . In the end, it was a bit depressing, really, because Vic doesn't really save the day or anything, so I scrapped it for a different power. But I thought I'd rework it into a stand-alone story for Vic and Matt fans.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12cdc4fb